// @flow
import { Component } from 'react';
import { createRemoteVideoMenuButtonEvent } from '../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../analytics/functions';
import { kickParticipantBackToLobby } from '../../lobby/actions.any';
;
/**
 * Abstract dialog to confirm a remote participant kick back to lobby action.
 */
export default class AbstractKickToLobbyDialog extends Component {
    /**
     * Initializes a new {@code AbstractKickToLobbyDialog} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this._onSubmit = this._onSubmit.bind(this);
    }
    /**
 * Callback for the confirm button.
 *
 * @private
 * @returns {boolean} - True (to note that the modal should be closed).
 */
    _onSubmit() {
        const { dispatch, participantID } = this.props;
        sendAnalytics(createRemoteVideoMenuButtonEvent('lobby.kick-back.button', { 'participant_id': participantID }));
        dispatch(kickParticipantBackToLobby(participantID));
        return true;
    }
}
